import { ListItemIcon, ListItemText, Typography } from '@mui/material';

import styles from './menu-item.module.scss';

type MenuItemProps = {
  icon: React.ReactNode;
  text: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const MenuItem = ({ icon, text, onClick }: MenuItemProps) => {
  return (
    <button onClick={(e) => onClick(e)} className={styles.menuItem}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText>
        <Typography>{text}</Typography>
      </ListItemText>
    </button>
  );
};
